
export const getUrlParamsLowerCase = (search) => {
    const urlParams = new URLSearchParams(search);
    return new Map([...urlParams].map(([key, value]) => [key.toLowerCase(), value]));
}

export const removeUrlParameter = (name) => {
    const url = new URL(window.location.href);
    if (!url) return undefined;
    const target = name?.toLowerCase();
    for (const [key, value] of url.searchParams?.entries()) {
        if (key?.toLowerCase() === target) {
            url.searchParams.delete(key);
        }
    }
    return url;
}